
import React from 'react';
import { SimulationConfig, SimulationMode } from './types';
import { SectionLabel } from './SectionLabel';
import { SmartInput } from './SmartInput';

interface ModeSelectorSectionProps {
  config: SimulationConfig;
  setConfig: React.Dispatch<React.SetStateAction<SimulationConfig>>;
}

export const ModeSelectorSection: React.FC<ModeSelectorSectionProps> = ({ config, setConfig }) => {
  const modes: SimulationMode[] = ['SPAWNER', 'DRAWER', 'TRAIL', 'ESCAPE', 'RHYTHMIC'];
  
  const updateTitle = (mode: SimulationMode, val: string) => {
    const key = mode === 'SPAWNER' ? 'spawnerTitle' : mode === 'DRAWER' ? 'drawerTitle' : mode === 'ESCAPE' ? 'escapeTitle' : mode === 'RHYTHMIC' ? 'rhythmicTitle' : 'trailTitle';
    setConfig(prev => ({ ...prev, [key]: val }));
  };

  const getTitle = () => {
      switch(config.mode) {
          case 'SPAWNER': return config.spawnerTitle;
          case 'DRAWER': return config.drawerTitle;
          case 'ESCAPE': return config.escapeTitle;
          case 'RHYTHMIC': return config.rhythmicTitle;
          default: return config.trailTitle;
      }
  };

  return (
    <>
      <SectionLabel icon="fa-layer-group" darkMode={config.darkMode}>Simulation Mode</SectionLabel>
      <div className={`grid grid-cols-3 gap-2 p-1 w-full rounded-xl mb-4 ${config.darkMode ? 'bg-neutral-800' : 'bg-neutral-100'}`}>
        {modes.map(m => (
          <button key={m} onClick={() => setConfig(prev => ({ ...prev, mode: m }))} className={`text-[8px] font-black py-2 rounded-lg transition-all ${config.mode === m ? (config.darkMode ? 'bg-neutral-700 text-white' : 'bg-white text-neutral-900 shadow-sm') : 'text-neutral-500'}`}>
            {m}
          </button>
        ))}
      </div>
      <input 
        type="text" 
        value={getTitle()} 
        onChange={(e) => updateTitle(config.mode, e.target.value)} 
        className={`w-full px-3 py-2 border rounded-xl text-xs font-bold outline-none transition-all mb-4 ${config.darkMode ? 'bg-neutral-800 border-neutral-700 text-white' : 'bg-neutral-50 border-neutral-200 text-neutral-800'}`} 
        placeholder="Mode Title" 
      />
      {config.mode !== 'RHYTHMIC' && (
          <SmartInput label="Container Radius" min={50} max={600} value={config.containerRadius} onChange={v => setConfig(p => ({...p, containerRadius: v}))} darkMode={config.darkMode} />
      )}
    </>
  );
};
